import './esqueci-senha.css'
import google_logo from '../../assets/google_logo.webp'
import Icon from '@mdi/react';
import { mdiAlertCircleOutline, mdiEye, mdiEyeClosed } from '@mdi/js'
import { useEffect, useState } from 'react'
import {API_BASE_URL} from '../../global.js'
import { useNavigate } from "react-router-dom";
import LoadingElement from '../components/loading_element/index.js';

export default function EsqueciSenha({isAuth, setIsAuth}) {

    const navigate = useNavigate();
    useEffect(() => {
        const auth = localStorage.getItem("auth");
        if (auth === "true") {
            navigate('/Painel')
        }
    }, []);

    const [codigo, setCodigo] = useState('');
    const [email, setEmail] = useState('');
    const [seePassword, setSeePassword] = useState(false);

    const [senha, setSenha] = useState('');

    const [erro, setErro] = useState(false);
    const [erroMsg, setErroMsg] = useState('');

    const [emailEnviado, setEmailEnvaido] = useState(false);
    const [codigoValido, setCodigoValido] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingCodigo, setLoadingCodigo] = useState(false);
    const [loadingPassword, setLoadingPassword] = useState(false);
    const [done, setDone] = useState(false);

    const validarEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const EnviarEmail = async () => {
        setLoading(true);
        if(email === ''){
            setErro(true); 
            setErroMsg("Campo 'E-mail' não pode ficar em branco");
            setLoading(false);
            return;
        } 
        if(!validarEmail(email)){
            setErro(true);
            setErroMsg("Insira um e-mail realmente válido");
            setLoading(false);
            return;
        }
        
        try {
            const response = await fetch(`${API_BASE_URL}/auth/esqueci-senha.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials:'include',
                body:JSON.stringify({
                    email:email
                })
            });

            const data = await response.json();   
            if(data.status === 'success'){
                setLoading(false)
                setEmailEnvaido(true)
            }else{
                setErro(true);
                setErroMsg(data.msg);
                setLoading(false);
            }
           
        } catch (error) {
            console.log('Erro de conexão:', error);
        }
    }

    const handleCodigo = (value) => {
        const somenteNumeros = value.slice(0, 6);
        setCodigo(somenteNumeros);
    }


    const validarCodigo = async () => {
        setLoadingCodigo(true);
         if(codigo === ''){
            setErro(true); 
            setErroMsg("Campo 'Código' não pode ficar em branco");
            return;
        } 

        if(codigo.length < 6){
            setErro(true); 
            setErroMsg("Código inválido");
            return;
        } 

        try {
            const response = await fetch(`${API_BASE_URL}/auth/esqueci-senha_validar_codigo.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials:'include',
                body:JSON.stringify({
                    codigo:codigo,
                    email:email
                })
            });

            const data = await response.json();   
            if(data.status === 'success'){
                setLoadingCodigo(false)
                setCodigoValido(true)
            }else{
                setErro(true);
                setErroMsg(data.msg);
                setLoadingCodigo(false);
                setCodigoValido(false);
            }
           
        } catch (error) {
            console.log('Erro de conexão:', error);
        }
    }


    const validarSenha = (senha) => {
        const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,24}$/;
        return regex.test(senha);
    }


    const concluir = async () =>{
        setLoadingPassword(true);
        if(senha === ''){
            setErro(true); 
            setErroMsg("Campo 'Senha' não pode ficar em branco");
            setLoadingPassword(false);
            return;
        } 
        if(!validarSenha(senha)){
            setErro(true);
            setErroMsg("A senha deve ter entre 8 e 24 caracteres, incluir uma letra maiúscula, um número e um caractere especial");
            setLoadingPassword(false);
            return;
        }

        const response = await fetch(`${API_BASE_URL}/auth/alterar-senha.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials:'include',
            body:JSON.stringify({
                senha:senha,
                email:email
            })
        });

        const data = await response.json();   
        if(data.status === 'success'){
            setLoadingPassword(false);
            setDone(true)
        }else{
            setDone(false);
            setErro(true);
            setErroMsg(data.msg);
            setLoadingCodigo(false);
            setLoadingPassword(false);
        }
    }

    return(
        <div className="esqueci_senha_body">
            <div className='esqueci_senha_box-esqueci_senha'>
                {!done ? <div className='esqueci_senha_title'>
                    <h1>Recuperação de senha</h1>
                    <p>Insira seu e-mail para receber o código de recuperação</p>
                </div> :
                <div className='esqueci_senha_title'>
                    <h1>Sua senha foi alterada com sucesso</h1>
                    <p>Clique abaixo para fazer login</p>
                </div> 
                }

                {erro &&
                    <div className='error-msg'>
                        <p><Icon path={mdiAlertCircleOutline} size={0.75} />{erroMsg}</p>
                    </div>}
                

                {!emailEnviado && !codigoValido && !done && <section className='group_default-cadastro'>
                    <div className='auth-input-group_default'>
                        <label for=''>E-mail</label>
                        <input type='text' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Insira seu e-mail cadastrado'></input>
                    </div>  
                    <button onClick={()=>EnviarEmail()}>{!loading ? 'Enviar E-mail' : <LoadingElement color={"#fff"} size={1}></LoadingElement>}</button>
                </section>}  

                {emailEnviado && !codigoValido && !done && <section className='group_default-cadastro'>
                    <div className='auth-input-group_default'>
                        <label for=''>Código</label>
                        <input type='text' value={codigo} onChange={(e) => handleCodigo(e.target.value)} placeholder='Insira o código'></input>
                    </div>                  

                    <button onClick={()=>{validarCodigo()}}>{!loadingCodigo ? 'Continuar' : <LoadingElement color={"#fff"} size={1}></LoadingElement>}</button>
                </section>}

                {emailEnviado && codigoValido && !done && 
                <section className='group_default-cadastro'>
                    <div className='auth-input-group_default'>
                        <label for=''>Nova senha</label>
                        {!seePassword ? (
                            <input type='password' value={senha} onChange={(e)=>setSenha(e.target.value)} placeholder='Insira sua senha'></input>
                        ):(
                            <input type='text' value={senha} onChange={(e)=>setSenha(e.target.value)} placeholder='Insira sua senha'></input>
                        )
                        }
                        
                        {seePassword ? (
                            <button id='reveal_password' onClick={()=>setSeePassword(false)}>
                                <Icon path={mdiEyeClosed} size={1} />
                            </button>
                        ):(
                            <button id='reveal_password' onClick={()=>setSeePassword(true)}>
                                <Icon path={mdiEye} size={1} />
                            </button>
                        )}  
                    </div>                  

                    <button onClick={()=>{concluir()}}>{!loadingPassword? 'Concluir' : <LoadingElement color={"#fff"} size={1}></LoadingElement>}</button>
                </section>
                }

                {emailEnviado && codigoValido && done && 
                
                <section className='group_default-cadastro'>                             

                    <button onClick={()=>{navigate('/Autenticacao')}}>Continuar para login</button>
                </section>
                
                }
                
            </div>
        </div>
    )
}